

















































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";
import { GetI18nStringFromUpdateType, UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { UpdatePackageInstallationsCount } from "@/model/data/updates/UpdatePackageInstallationsCount";

export default Vue.extend({
    data() {
        return {
            selectedItems: [],
            lastSelectedItemsLength: 0,
            search: "",
            openMenu: false,
        };
    },
    computed: {
        ...mapState({
            isUpdatePackagesListFetching: (state: RootState) => state.updatePackages.isUpdatePackagesListFetching,
            updatePackagesList: (state: RootState): UpdatePackageInstallationsCount[] => state.updatePackages.updatePackagesList,
        }),
        availableData() {
            let data = [];
            this.updatePackagesList
                .map((u) => u.updateType)
                .filter((value, index, array) => array.indexOf(value) === index)
                .forEach((type) => {
                    data.push({ name: this.$t(GetI18nStringFromUpdateType(type as UpdateTypeEnum)), value: type, selected: this.selectedItems.includes(type) ? 1 : 0 });
                });
            data.sort((a, b) => {
                return b.selected - a.selected || a.name.localeCompare(b.name);
            });
            return data;
        },
    },
    methods: {
        GetI18nStringFromUpdateType,
        filter() {
            this.$emit("input", this.selectedItems);
            this.lastSelectedItemsLength = this.selectedItems.length;
            this.openMenu = false;
            this.search = "";
        },
    },
});
